var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "trim mb-3 d-md-flex",
      class: { active: _vm.active },
      on: { click: _vm.select }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "top d-flex justify-content-between order-sm-2 flex-sm-grow-1"
        },
        [
          _c("div", { staticClass: "name" }, [
            _c("div", { staticClass: "year-make" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.trim.year) +
                  " " +
                  _vm._s(_vm.trim.make) +
                  " " +
                  _vm._s(_vm.trim.model) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "model-trim" }, [
              _vm._v(_vm._s(_vm.trim.trim) + " " + _vm._s(_vm.trim.name))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "starting-at" }, [
            _c("small", [_vm._v("starting at")]),
            _vm._v(" "),
            _c("div", { staticClass: "price" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm._f("numeral")(_vm.trim.startingAt, "$0,0")) +
                  "\n            "
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "vehicle-image text-center order-sm-1 mr-sm-3" },
        [_c("trim-image", { attrs: { trim: _vm.trim, transparent: "" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bottom text-center d-md-none" },
        [
          _c("div", { staticClass: "engine-transmission" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.trim.engineDisplacement) +
                " " +
                _vm._s(_vm.trim.transmissionDescription) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "more-wrapper" },
            [
              !_vm.detailsOpen
                ? _c(
                    "b-link",
                    {
                      staticClass: "d-flex flex-column",
                      on: {
                        click: function($event) {
                          _vm.detailsOpen = true
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "ion-chevron-down",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("more")])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-collapse",
                {
                  staticClass: "more-details m-3",
                  attrs: { id: "details" },
                  model: {
                    value: _vm.detailsOpen,
                    callback: function($$v) {
                      _vm.detailsOpen = $$v
                    },
                    expression: "detailsOpen"
                  }
                },
                [
                  _vm.baseTrim
                    ? _c("p", [
                        _vm._v(
                          "\n                    Includes select features of " +
                            _vm._s(_vm.baseTrim.trim) +
                            " model\n                    plus...\n                "
                        )
                      ])
                    : _c("p", [
                        _vm._v(
                          "\n                    Includes the following standard features...\n                "
                        )
                      ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "standards" }, [
                    _c(
                      "ul",
                      _vm._l(_vm.standardDiff, function(standard, key) {
                        return _c("li", { key: key }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(standard.value) +
                              "\n                        "
                          )
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "b-link",
                          {
                            on: { click: () => _vm.viewAllOptions(_vm.trim.id) }
                          },
                          [
                            _vm._v(
                              "\n                            View All\n                        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-link",
                    {
                      staticClass: "d-flex flex-column",
                      on: {
                        click: function($event) {
                          _vm.detailsOpen = false
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "ion-chevron-up",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("view less")])
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("action-buttons", { attrs: { trim: _vm.trim } })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }